// Day 7 — one week left.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, esc, p } from "../../layouts/chrome";
import { NO_PAYMENT, pricedEmailHtml } from "../../layouts/priced";
import { brand } from "../brand";

export const subject = ({ renewalDate }: EmailData) =>
  `One week left: your ${brand.name} renewal on ${longDate(renewalDate)}`;

export const html = (data: EmailData) =>
  pricedEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    quotes: data.quotes ?? [],
    payment: data.payment ?? NO_PAYMENT,
    policyRef: data.policyRef,
    versionRef: data.versionRef,
    bodyHtml: p(
      `Just a quick reminder from ${brand.name} that your insurance policy for ${b(`'${esc(data.companyName)}' will expire in one week on ${longDate(data.renewalDate)}`)}. Renew now to avoid a gap in your cover — one call and it's done.`,
    ),
  });
